import React from 'react';
import { ContractChipList } from '../../_components/atoms/ComparisonTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { ComparisonDataPros } from '../../pages/DocumentComparisonPage';
import { formatDate } from './helper';
import {
  TextWithIcon,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Checkbox, Grid } from '@mui/material';
import { getTextWithToolTip } from './riskPatientDetailsHelper';
import {
  ChevronRight,
  DottedText,
  Folder2,
  Document,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { getTruncatedText } from '../../pages/MemberSummaryPage';
import clsx from 'clsx';
import { getChipComponent } from './contractAIQHelper';

export const COMP_LIB_TABLE_COLUMNS = [
  { name: 'Comparison Name' },
  { name: 'Vendor Type' },
  { name: 'Created On' },
  { name: 'Documents Compared' },
  { name: 'Parameters Compared' },
];

export const formatComparisonTableData = (data: ComparisonDataPros[]) => {
  const tableData: any[] = [];
  data.map((item: ComparisonDataPros) => {
    const otherData = [];
    otherData.push(
      <Typography
        fontSize="14px"
        fontType="medium"
        textColor={patientAccessTheme.palette.text.highemphasis}
        styleProps={{
          width: '180px',
        }}
      >
        {getTextWithToolTip(item?.vendor_type || '', 20)}
      </Typography>,
    );
    otherData.push(
      <Typography
        fontSize="14px"
        fontType="medium"
        textColor={patientAccessTheme.palette.text.highemphasis}
        styleProps={{
          width: '90px',
        }}
      >
        {formatDate(item?.createdAt, 'DD MMM YYYY')}
      </Typography>,
    );
    otherData.push(
      <Grid style={{ width: '300px', overflow: 'hidden' }}>
        {item?.documents && item?.documents?.length > 0 ? (
          <ContractChipList
            selectedItems={
              item?.documents?.map((doc: any) => doc.document_name) || []
            }
          />
        ) : (
          ''
        )}
      </Grid>,
    );
    otherData.push(
      <Grid style={{ width: '300px', overflow: 'hidden' }}>
        {item?.comparison_parameters &&
        item.comparison_parameters.length > 0 ? (
          <ContractChipList
            selectedItems={
              item?.comparison_parameters?.map(
                (param: any) => param.parameter,
              ) || [null]
            }
          />
        ) : (
          ''
        )}
      </Grid>,
    );

    tableData.push({
      // company_name: (
      //   <Typography
      //     fontSize="14px"
      //     fontType="medium"
      //     textColor={patientAccessTheme.palette.text.primary[500]}
      //     styleProps={{ width: '200px' }}
      //   >
      //     {getTextWithToolTip(item?.comparison_name || '', 20)}
      //   </Typography>
      // ),
      _id: item._id,
      company_name: item?.comparison_name || '',
      status: item?.status,
      // status: 'Ready',
      contract_ids: item?.contract_ids,
      vendor_type: item?.vendor_type,
      otherData,
    });
  });
  return tableData;
};

interface subParameter {
  name: string;
  description: string;
  position: number;
  key: string;
}

interface comparisonparametersProps {
  parameter: string;
  description: string;
  position: number;
  subParameter: subParameter[];
}

export interface comparisonObjectProps {
  comparison_name: string;
  vendor_type: string;
  contract_ids: string[];
  comparison_parameters: comparisonparametersProps[];
  status: string;
  vendor_id: string;
  vendor_identifier: string;
}

export const getDocumentSelectionTableColumns: any = (
  classes: any,
  selectedRowIds: string[],
  onRowSelectionChange: any,
  showPlanDocs: boolean,
  totalContracts: number,
) => {
  return showPlanDocs
    ? [
        {
          id: 'selection',
          Header: ({ rows }: any) => {
            const totalRows = rows.length;
            const selectedCount = selectedRowIds.length;

            const allSelected = selectedCount === totalRows && totalRows > 0;
            const noneSelected = selectedCount === 0;
            const isIndeterminate = !allSelected && !noneSelected;

            return (
              <Checkbox
                checked={allSelected}
                indeterminate={isIndeterminate}
                onChange={() => {
                  if (allSelected || isIndeterminate) {
                    onRowSelectionChange([], []);
                  } else {
                    const allRowIds = rows.map((row: any) => row?.original?.id);
                    const allContracts = rows.map((row: any) => row?.original);
                    onRowSelectionChange(allRowIds, allContracts);
                  }
                }}
                style={{
                  color:
                    allSelected || isIndeterminate
                      ? patientAccessTheme.palette.primary[500]
                      : patientAccessTheme.palette.checkbox?.border1,
                  height: '20px',
                  width: '20px',
                  borderRadius: '2px',
                }}
              />
            );
          },
          Cell: ({ row }: any) => {
            const isSubRow = row.depth > 0;
            return !isSubRow ? (
              <Checkbox
                checked={selectedRowIds.includes(row?.original?.id)}
                onChange={() =>
                  onRowSelectionChange?.(row?.original?.id, row?.original)
                }
                style={{
                  color: selectedRowIds.includes(row?.original?.id)
                    ? patientAccessTheme.palette.primary[500]
                    : patientAccessTheme.palette.checkbox?.border1,
                  height: '20px',
                  width: '20px',
                  borderRadius: '2px',
                }}
              />
            ) : (
              <></>
            );
          },
        },
        {
          sequenceNo: 0,
          Header: (
            <Typography
              className={clsx(
                classes.tableFirstColumn,
                classes.tableHeaderText,
              )}
              style={{ width: '700px', paddingLeft: '16px' }}
            >
              {'Contracts/ Plan Documents'}
            </Typography>
          ),
          Footer: 'Contracts/ Plan Documents',
          accessor: 'name',
          cellType: 'none',
          icon: 'none',
          Cell: ({ row, value }: any) => {
            const isSubRow = row.depth > 0;
            return (
              <Grid
                container
                style={{
                  width: '700px',
                  paddingLeft: isSubRow ? '54px' : '16px',
                }}
                sx={{
                  alignItems: 'center',
                }}
              >
                {isSubRow ? (
                  <>
                    <TextWithIcon
                      startIcon={
                        <Document
                          color={patientAccessTheme.palette.primary[500]}
                          width={'16px'}
                          height={'16px'}
                        />
                      }
                      label={<DottedText text={row?.original?.document_name} />}
                      startIconRightMargin="8px"
                    />
                  </>
                ) : (
                  <>
                    {row?.canExpand && (
                      <Grid
                        style={{
                          height: '24px',
                          marginRight: '12px',
                          transform: row?.isExpanded ? 'rotate(90deg)' : 'none',
                        }}
                      >
                        <ChevronRight
                          style={{
                            height: '24px',
                            width: '24px',
                            color: patientAccessTheme.palette.primary[500],
                            cursor: 'pointer',
                          }}
                        />
                      </Grid>
                    )}
                    <TextWithIcon
                      handleOnClick={() => {}}
                      startIcon={<Folder2 />}
                      label={<DottedText text={value ? value : '...'} />}
                      startIconRightMargin="8px"
                    />
                  </>
                )}
              </Grid>
            );
          },
        },
        {
          sequenceNo: 3,
          Header: (
            <Typography
              className={classes.tableHeaderText}
              style={{ width: '150px', paddingLeft: '12px' }}
            >
              {'Total Files'}
            </Typography>
          ),
          Footer: 'Total Files',
          accessor: 'total_files',
          cellType: 'none',
          icon: 'none',
          Cell: ({ value }: any) => (
            <Typography
              style={{ width: '150px', paddingLeft: '12px' }}
              className={classes.tableCellText}
            >
              {value}
            </Typography>
          ),
        },
      ]
    : [
        {
          id: 'selection',
          Header: ({ rows }: any) => {
            const selectedCount = selectedRowIds.length;

            const allSelected =
              selectedCount === totalContracts && totalContracts > 0;
            const noneSelected = selectedCount === 0;
            const isIndeterminate = !allSelected && !noneSelected;

            return (
              <Checkbox
                checked={allSelected}
                indeterminate={isIndeterminate}
                onChange={() => {
                  if (allSelected || isIndeterminate) {
                    onRowSelectionChange([], []);
                  } else {
                    const allRowIds = rows.map((row: any) => row?.original?.id);
                    const allContracts = rows.map((row: any) => row?.original);
                    onRowSelectionChange(allRowIds, allContracts);
                  }
                }}
                style={{
                  color:
                    allSelected || isIndeterminate
                      ? patientAccessTheme.palette.primary[500]
                      : patientAccessTheme.palette.checkbox?.border1,
                  height: '20px',
                  width: '20px',
                  borderRadius: '2px',
                }}
              />
            );
          },
          Cell: ({ row }: any) => {
            const isSubRow = row.depth > 0;
            return !isSubRow ? (
              <Checkbox
                checked={selectedRowIds.includes(row?.original?.id)}
                onChange={() =>
                  onRowSelectionChange?.(row?.original?.id, row?.original)
                }
                style={{
                  color: selectedRowIds.includes(row?.original?.id)
                    ? patientAccessTheme.palette.primary[500]
                    : patientAccessTheme.palette.checkbox?.border1,
                  height: '20px',
                  width: '20px',
                  borderRadius: '2px',
                }}
              />
            ) : (
              <></>
            );
          },
        },
        {
          sequenceNo: 0,
          expansion: true,
          Header: (
            <Typography
              className={clsx(
                classes.tableFirstColumn,
                classes.tableHeaderText,
              )}
              style={{
                width: '400px',
                paddingLeft: '48px',
              }}
            >
              {'Vendor Name / Draft Name'}
            </Typography>
          ),
          Footer: 'Vendor Name / Draft Name',
          accessor: 'name',
          cellType: 'none',
          icon: 'none',
          Cell: ({ row, value }: any) => {
            const isSubRow = row.depth > 0;

            return (
              <Grid
                container
                style={{
                  width: '400px',
                  paddingLeft: isSubRow ? '54px' : '16px', // indent subrows
                }}
                sx={{
                  alignItems: 'center',
                }}
              >
                {isSubRow ? (
                  // ── Subrow — show document name with doc icon ─────────
                  <TextWithIcon
                    startIcon={
                      <Document
                        color={patientAccessTheme.palette.primary[500]}
                        width={'16px'}
                        height={'16px'}
                      />
                    }
                    label={
                      <DottedText text={row?.original?.document_name || '-'} />
                    }
                    startIconRightMargin="8px"
                  />
                ) : (
                  // ── Parent row — show chevron + folder + name ─────────
                  <>
                    {/* Chevron expand toggle */}
                    {row?.canExpand && (
                      <Grid
                        style={{
                          height: '24px',
                          marginRight: '12px',
                          transform: row?.isExpanded ? 'rotate(90deg)' : 'none',
                          transition: 'transform 0.2s ease',
                          cursor: 'pointer',
                        }}
                      >
                        <ChevronRight
                          style={{
                            height: '20px',
                            width: '20px',
                            color: patientAccessTheme.palette.primary[500],
                          }}
                        />
                      </Grid>
                    )}
                    {/* Folder icon + name */}
                    <TextWithIcon
                      startIcon={<Folder2 />}
                      label={getTextWithToolTip(value || '...', 35, {
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: patientAccessTheme.palette.text.highemphasis,
                        maxWidth: '200px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      })}
                      startIconRightMargin="8px"
                    />
                  </>
                )}
              </Grid>
            );
          },
        },
        {
          sequenceNo: 1,
          Header: (
            <Typography
              className={classes.tableHeaderText}
              style={{ width: '300px' }}
            >
              {'Group Name'}
            </Typography>
          ),
          Footer: 'Group Name',
          accessor: 'employer_name',
          cellType: 'none',
          icon: 'none',
          Cell: ({ row, value }: any) => {
            const isSubRow = row.depth > 0;

            // Subrow shows document_type in Group Name column
            return isSubRow ? (
              <Typography
                style={{ width: '300px', marginLeft: '48px' }}
                className={classes.tableCellText}
              >
                {row?.original?.document_type || '-'}
              </Typography>
            ) : (
              <Typography
                style={{ width: '300px' }}
                className={classes.tableCellText}
              >
                {value ? getTruncatedText(value, '350px') : '-'}
              </Typography>
            );
          },
        },
        {
          sequenceNo: 3,
          Header: (
            <Typography
              className={classes.tableHeaderText}
              style={{ width: '150px', paddingLeft: '12px' }}
            >
              {'Total Files'}
            </Typography>
          ),
          Footer: 'Total Files',
          accessor: 'total_files',
          cellType: 'none',
          icon: 'none',
          Cell: ({ row, value }: any) => {
            const isSubRow = row.depth > 0;
             
            if (isSubRow) {
              return <></>;
            }
            return (
              <Typography
                style={{ width: '150px', paddingLeft: '12px' }}
                className={classes.tableCellText}
              >
                {value}
              </Typography>
            );
          },
        },
        {
          sequenceNo: 4,
          Header: (
            <Typography
              className={classes.tableHeaderText}
              style={{ width: '150px', paddingLeft: '12px' }}
            >
              {'Contract Type'}
            </Typography>
          ),
          Footer: 'Contract Type',
          accessor: 'contract_type',
          cellType: 'none',
          icon: 'none',
          Cell: ({ row, value }: any) => {
            const isSubRow = row.depth > 0;
             
            if (isSubRow) {
              return <></>;
            }
            let chipType: 'Fully Met' | 'Not Met' | '' = '';
            switch (value) {
              case 'Archive':
                chipType = 'Not Met';
                break;
              case 'Active':
                chipType = 'Fully Met';
                break;
              default:
                chipType = '';
            }
            return (
              <Typography
                style={{ width: '150px', paddingLeft: '12px' }}
                className={classes.tableCellText}
              >
                {getChipComponent(chipType, value, '80px')}
              </Typography>
            );
          },
        },
        {
          sequenceNo: 5,
          Header: (
            <Typography
              className={classes.tableHeaderText}
              style={{ width: '160px', paddingLeft: '12px' }}
            >
              {'Effective Date'}
            </Typography>
          ),
          Footer: 'Effective Date',
          accessor: 'effective_date',
          cellType: 'none',
          icon: 'none',
          Cell: ({ row, value }: any) => {
            const isSubRow = row.depth > 0;
             
            if (isSubRow) {
              return <></>;
            }
            return (
              <Typography
                style={{ width: '160px', paddingLeft: '12px' }}
                className={classes.tableCellText}
              >
                {value || '-'}
              </Typography>
            );
          },
        },
      ];
};
